/** Reiwa era year for calendar year (令和X年分). Reiwa 1 = 2019. */
export function reiwaYearFromDate(date: Date = new Date()): number {
  return date.getFullYear() - 2018;
}

export function buildOfficialFormTitleJa(reiwaYear: number): string {
  return `令和${reiwaYear}年分　給与所得者の扶養控除等（異動）申告書`;
}
